import { BookStrategyFactoryService } from '@aca-new/app/pages/book/shared/services/book-strategy/book-strategy-factory/book-strategy-factory.service';
import { IBookFromPreviousOrderDialogData } from '@aca-new/app/pages/bookings/pages/previous-order-item/components/book-from-previous-order/shared/models/interfaces/book-from-previous-order-dialog-data.interface';
import {
  IBookFromPreviousTableStrategy,
  IPreviousOrderSelect,
} from '@aca-new/app/pages/bookings/pages/previous-order-item/shared/interfaces/book-from-previous-table-strategy.interface';
import { TableStrategyFactoryService } from '@aca-new/app/pages/bookings/pages/previous-order-item/shared/services/table-stratetgy/table-strategy-factory.service';
import { IPreviousOrders } from '@aca-new/app/pages/bookings/shared/models/interfaces/bookings.interface';
import { IPreviousOrder } from '@aca-new/app/pages/main/shared/components/aside/shared/components/aside-menu/share/models/interfaces/previous-order.interface';
import { AbstractSearchTableComponent } from '@aca-new/app/shared/components/abstract-search-table/abstract-search-table.component';
import { DataTableComponent } from '@aca-new/app/shared/components/data-table/data-table.component';
import { ESortOrder } from '@aca-new/app/shared/components/data-table/shared/models/enums/sort-order.enum';
import { IDataTableQueryParams } from '@aca-new/app/shared/components/data-table/shared/models/interfaces/data-table-query-params.interface';
import { IDataTableTransformCell } from '@aca-new/app/shared/components/data-table/shared/models/interfaces/data-table-transform-cell.interface';
import { DialogRef } from '@aca-new/app/shared/components/modal/shared/classes/dialog.ref';
import { DIALOG_DATA } from '@aca-new/app/shared/components/modal/shared/tokens/dialog.token';
import { ETableDataType } from '@aca-new/app/shared/components/table/shared/enums/table-data-type.enum';
import { ITableBodyRow } from '@aca-new/app/shared/components/table/shared/interfaces/table-data.interface';
import { ITableHeader } from '@aca-new/app/shared/components/table/shared/interfaces/table-header.interface';
import { ITableSort } from '@aca-new/app/shared/components/table/shared/interfaces/table-sort.interface';
import { GTM_ANALYTICS_EVENT_CATEGORY, GTM_RENEW_EVENTS } from '@aca-new/app/shared/constants/gtm-analytics.constants';
import { EBusinessSolution } from '@aca-new/app/shared/models/enums/business-solution.enum';
import { ELocalForageKeys } from '@aca-new/app/shared/models/enums/localforage-keys.enum';
import { EPostMessageType } from '@aca-new/app/shared/models/enums/post-message-type.enum';
import { EServiceType } from '@aca-new/app/shared/models/enums/service-type.enum';
import { EStorageKeys } from '@aca-new/app/shared/models/enums/storage-keys.enum';
import { ISelect } from '@aca-new/app/shared/models/interfaces/select.interface';
import { ServiceTypeIceCubeStylePipe } from '@aca-new/app/shared/pipes/service-type-ice-cube-style/service-type-ice-cube-style.pipe';
import { QimaButtonService } from '@aca-new/app/shared/services/exported-services/qima-button/qima-button.service';
import { QimaIconService } from '@aca-new/app/shared/services/exported-services/qima-icon/qima-icon.service';
import { QimaInputService } from '@aca-new/app/shared/services/exported-services/qima-input/qima-input.service';
import { AcaMessageService } from '@aca-new/app/shared/services/post-message-services/aca-message/aca-message.service';
import { StorageService } from '@aca-new/app/shared/services/storage-services/storage.service';
import { UserIsolatedLocalForageService } from '@aca-new/app/shared/services/storage-services/user-isolated-localforage.service';
import { GoogleAnalyticsService } from '@aca-new/app/shared/services/third-party-services/google-analytics/google-analytics.service';
import { AppUserSettingService } from '@aca-new/app/shared/services/user-services/app-user-setting/app-user-setting.service';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit, Optional, signal, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { QimaOptionalType } from '@qima/ngx-qima';
import { assign, cloneDeep } from 'lodash/index';
import { take } from 'rxjs/operators';

@UntilDestroy()
@Component({
  standalone: false,
  selector: 'app-book-from-previous-order',
  templateUrl: './book-from-previous-order.component.html',
  styleUrls: ['./book-from-previous-order.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class BookFromPreviousOrderComponent extends AbstractSearchTableComponent implements OnInit {
  @ViewChild(DataTableComponent) public dataTable: DataTableComponent | undefined;

  public isSubmitLoading: boolean = false;
  public isDataTableLoading = signal<boolean>(false);

  public tableStrategy: IBookFromPreviousTableStrategy | undefined;

  public readonly initialQueryParams: IDataTableQueryParams = {
    keyword: '',
    pageSize: this.pageSizes[0],
    page: 1,
    sortField: '',
    sortType: ESortOrder.DESC,
  };

  public tableHeaders: ITableHeader[] = [];
  public queryParams: IDataTableQueryParams = cloneDeep(this.initialQueryParams);

  public currentBusinessType: string = '';
  public businessSolutionOptions: ISelect[] = [];

  public selectedServiceType: EServiceType = EServiceType.PSI;
  public selectedRow: QimaOptionalType<ITableBodyRow> = undefined;
  public activeRowIndex: number = -1;
  public transformIceCube = {
    [ETableDataType.ICE_CUBE]: (data: IDataTableTransformCell): void => {
      data.cellData.iceCubeStyle = this._serviceTypeIceCubeStylePipe.transform(data.cellData.label || '');
    },
  };

  public serviceTypes: ISelect[] = [
    {
      value: 'PSI',
      label: 'APP_ASIDE.ASIDE_MENU.PRE_SHIPMENT_INSPECTION',
    },
    {
      value: 'IPC',
      label: 'APP_ASIDE.ASIDE_MENU.INITIAL_PRODUCTION_CHECK',
    },
    {
      value: 'DUPRO',
      label: 'APP_ASIDE.ASIDE_MENU.DURING_PRODUCTION_INSPECTION',
    },
    {
      value: 'CLC',
      label: 'APP_ASIDE.ASIDE_MENU.CONTAINER_LOADING_CHECK',
    },
    {
      value: 'PM',
      label: 'APP_ASIDE.ASIDE_MENU.PRODUCTION_MONITORING',
    },
    {
      value: 'SP',
      label: 'APP_ASIDE.ASIDE_MENU.SAMPLE_COLLECTION',
    },
    {
      value: 'SR',
      label: 'APP_ASIDE.ASIDE_MENU.SAMPLE_REVIEW',
    },
  ];

  private _preselectedOrderId: string | undefined;

  public constructor(
    @Inject(DialogRef) private readonly _dialogRef: DialogRef<QimaOptionalType<IPreviousOrderSelect>>,
    @Optional() @Inject(DIALOG_DATA) private readonly _dialogData: QimaOptionalType<IBookFromPreviousOrderDialogData>,
    private readonly _tableStrategyFactoryService: TableStrategyFactoryService,
    private readonly _serviceTypeIceCubeStylePipe: ServiceTypeIceCubeStylePipe,
    private readonly _appUserSettingService: AppUserSettingService,
    private readonly _acaMessageService: AcaMessageService,
    private readonly _bookStrategyFactoryService: BookStrategyFactoryService,
    private readonly _router: Router,
    private readonly _changeDetectorRef: ChangeDetectorRef,
    public readonly qimaButton: QimaButtonService,
    public readonly qimaInput: QimaInputService,
    public readonly qimaIcon: QimaIconService,
    storageService: StorageService,
    private readonly _userIsolatedLocalForageService: UserIsolatedLocalForageService,
    private readonly _googleAnalyticsService: GoogleAnalyticsService
  ) {
    super(storageService);
  }

  public get isStep2Visible(): boolean {
    return !!this.selectedRow && this.currentBusinessType === EBusinessSolution.INSPECTIONS;
  }

  public ngOnInit(): void {
    this._initBusinessSolutions();

    const dialogData = this._dialogData;

    if (dialogData?.businessSolution && dialogData.preselectedOrder && this.businessSolutionOptions.some((option): boolean => option.value === dialogData.businessSolution)) {
      this._applyDialogData(dialogData);

      return;
    }

    void this._userIsolatedLocalForageService.getItem<EBusinessSolution>(ELocalForageKeys.SELECTED_BUSINESS_SOLUTION).then((businessSolution): void => {
      const currentSolutions = this.businessSolutionOptions.map((solution): string => solution.value);

      this.onBusinessSolutionChange(businessSolution && currentSolutions.includes(businessSolution) ? businessSolution : this._getInitialBusinessSolution());
    });
  }

  public onDataTableIsLoading(isLoading: boolean): void {
    this.isDataTableLoading.set(isLoading);
  }

  public onBusinessSolutionChange(type: Readonly<string>): void {
    if (type !== this._dialogData?.businessSolution) {
      this._preselectedOrderId = undefined;
    }

    this.currentBusinessType = type;
    this.tableStrategy = this._tableStrategyFactoryService.getTableStrategyService(type);
    this.tableHeaders = this.tableStrategy.tableHeaders;
    this.resetQueryParams();
    this.queryParams.keyword = this._preselectedOrderId ? (this._dialogData?.searchKeyword ?? '') : '';
    this.setDataTableUrl();
  }

  public setDataTableUrl(): void {
    if (this.tableStrategy) {
      const urlParams = this.tableStrategy.getTableUrlParams(this.queryParams);
      const paramsForUrl = { ...urlParams };

      // Only convert pageNumber to page for Food Certification API (wqs/orders)
      if ('pageNumber' in paramsForUrl && this.tableStrategy.tableUrlPath.includes('/wqs/orders')) {
        paramsForUrl['page'] = paramsForUrl['pageNumber'];
        delete paramsForUrl['pageNumber'];
      }

      this.dataTableUrl = `${this.tableStrategy.tableUrlPath}?${new URLSearchParams(paramsForUrl)}`;
      this.selectedRow = undefined;
      this.activeRowIndex = -1;
      this._restorePreselectedRowSelection();
    }
  }

  public onSortClick(sortEvent: ITableSort): void {
    this.queryParams.sortType = sortEvent.isSortAsc ? ESortOrder.ASC : ESortOrder.DESC;
    this.queryParams.sortField = sortEvent.sortKey;
    this.setDataTableUrl();
  }

  public onTableRowClick(data: ITableBodyRow): void {
    this.selectedRow = data;
    this._preselectedOrderId = undefined;
  }

  public onPageLoaded(): void {
    this._selectPreselectedRowFromTable();
  }

  public close(): void {
    this._dialogRef.close();
  }

  public onSelectClick(): void {
    if (!this.selectedRow?.originData) {
      return;
    }

    /* eslint-disable @typescript-eslint/naming-convention -- GTM dataLayer keys */
    this._googleAnalyticsService.sendEvent({
      event: GTM_RENEW_EVENTS.previousOrderItemClick,
      event_category: GTM_ANALYTICS_EVENT_CATEGORY.userInteraction,
      event_label: 'Book From Previous Order Item',
      service_type: `${this.selectedServiceType}`,
      business_solution: `${this.currentBusinessType}`,
    });
    /* eslint-enable @typescript-eslint/naming-convention */

    this.isSubmitLoading = true;
    this._storageService.setItem(EStorageKeys.IS_BOOKING_FROM_PREVIOUS, 'true');

    const isAcaBookRoute: boolean = this._router.url.includes('/aca/book-');
    const currentStrategy = this._bookStrategyFactoryService.getCurrentStrategyService(this.currentBusinessType);
    const shouldCloseDialogOnOrderCreated = !(isAcaBookRoute && this.currentBusinessType === EBusinessSolution.LAB_TESTING);

    currentStrategy.bookFromPreviousOrder({
      isAcaBookRoute,
      previousOrder: this.selectedRow as unknown as IPreviousOrder,
      serviceType: this.selectedServiceType,
      dialogRef: this._dialogRef,
    });

    if (shouldCloseDialogOnOrderCreated) {
      this._acaMessageService
        .registerMessageHandler$(EPostMessageType.ORDER_CREATED_FROM_PREVIOUS_ORDER)
        .pipe(take(1), untilDestroyed(this))
        .subscribe((): void => {
          this.close();
        });
    } else {
      this.isSubmitLoading = false;
    }
  }

  public resetQueryParams(): void {
    this.activePage = 1;
    this.queryParams = assign(cloneDeep(this.initialQueryParams), { pageSize: this.queryParams.pageSize });
  }

  private _getInitialBusinessSolution(): string {
    return this.businessSolutionOptions[0].value;
  }

  private _initBusinessSolutions(): void {
    if (this._appUserSettingService.getEnableFoodCertification()) {
      this.businessSolutionOptions = [
        { label: 'APP_ASIDE.ASIDE_MENU.WQS', value: EBusinessSolution.FOOD_CERTIFICATION },
        { label: 'APP_ASIDE.ASIDE_MENU.SUPPLIER_AUDITS', value: EBusinessSolution.AUDITS },
      ];
      void this._userIsolatedLocalForageService.setItem(ELocalForageKeys.SELECTED_BUSINESS_SOLUTION, EBusinessSolution.FOOD_CERTIFICATION).then((): void => {
        this.onBusinessSolutionChange(EBusinessSolution.FOOD_CERTIFICATION);
      });

      return;
    }

    this.businessSolutionOptions = [
      {
        label: 'APP_ASIDE.ASIDE_MENU.PRODUCT_INSPECTIONS',
        value: EBusinessSolution.INSPECTIONS,
      },
      {
        label: 'APP_ASIDE.ASIDE_MENU.TESTING',
        value: EBusinessSolution.LAB_TESTING,
      },
      {
        label: 'APP_ASIDE.ASIDE_MENU.SUPPLIER_AUDITS',
        value: EBusinessSolution.AUDITS,
      },
    ];
  }

  /**
   * @param {IBookFromPreviousOrderDialogData} dialogData - Initialization data supplied by the caller
   * @returns {void}
   */
  private _applyDialogData(dialogData: IBookFromPreviousOrderDialogData): void {
    if (!dialogData.businessSolution) {
      return;
    }

    this._preselectedOrderId = dialogData.preselectedOrder?.originData.orderId;
    this.selectedServiceType = dialogData.selectedServiceType ?? this.selectedServiceType;
    this.onBusinessSolutionChange(dialogData.businessSolution);
  }

  /**
   * @returns {void}
   */
  private _restorePreselectedRowSelection(): void {
    if (!this._preselectedOrderId || !this._dialogData?.preselectedOrder || this.currentBusinessType !== this._dialogData.businessSolution) {
      return;
    }

    this.selectedRow = {
      originData: this._dialogData.preselectedOrder.originData,
      viewData: [],
    };
  }

  /**
   * @returns {void}
   */
  private _selectPreselectedRowFromTable(): void {
    if (!this._preselectedOrderId || !this.dataTable) {
      return;
    }

    const index = this.dataTable.tableViewData.findIndex((row): boolean => (row.originData as IPreviousOrders | undefined)?.orderId === this._preselectedOrderId);

    if (index < 0) {
      return;
    }

    this.activeRowIndex = index;
    this.selectedRow = this.dataTable.tableViewData[index];
    this._preselectedOrderId = undefined;
    this._changeDetectorRef.markForCheck();
  }
}
